import { useRouteError } from "react-router-dom";
import { AlertCircle } from "lucide-react";

interface RouterError {
  stack?: string;
}

export function ErrorBoundary() {
  const error = useRouteError() as RouterError;

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="max-w-2xl rounded-lg bg-destructive/10 p-8 text-center">
        <div className="mb-4 flex justify-center">
          <AlertCircle className="size-12 text-destructive" />
        </div>
        <h2 className="mb-2 text-xl font-semibold text-destructive">Oups ! Une erreur est survenue</h2>
        <div className="mb-4 text-sm text-muted-foreground">
          <p>Pour résoudre ce problème :</p>
          <ol className="mt-2 list-inside list-decimal text-left">
            <li>Faites une capture d'écran de cette page</li>
            <li>Contactez un administrateur en décrivant la situation et en lui envoyant la capture de cet écran</li>
          </ol>
        </div>
        {import.meta.env.DEV && (
          <div className="mt-6 rounded bg-slate-100 p-4 text-left">
            <p className="mb-2 text-sm font-medium">Détails techniques :</p>
            <pre className="overflow-auto whitespace-pre-wrap break-words text-xs">{error?.stack || JSON.stringify(error, null, 2)}</pre>
          </div>
        )}
      </div>
    </div>
  );
}
